import CardType from "./card";

export default interface PlayerType {
  id: string;
  name: string;
  hand: CardType[];
  turnToPlay: boolean;
}

export const INIT_PLAYER: PlayerType = {
  id: "",
  name: "",
  hand: [],
  turnToPlay: false,
};
